"use client";
import React from "react";
import Breadcrumb from "@/components/Common/Breadcrumb";

import Faq from "@/components/Faq/FaqRental";
import Newsletter from "@/components/Common/Newsletter";
import Categories from "@/components/Home/Categories";
import Navigation from "@/components/Category/Navigation";
import Content from "@/components/Category/Content";
import Coverage from "@/components/Category/Coverage";
import Products from "@/components/Category/Products";

const Category = ({
  category,
}: {
  category: {
    id: number;
    name: string;
    title: string;
    url: string;
    slug: string;
    content: React.ReactNode;
    categoryName?: string;
    areaName?: string;
    categoryId?: number;
  };
}) => {
  // Format slug akhir untuk breadcrumb
  const fullSlug = `/${category.url.replace(/\//g, "").toLowerCase()}${
    category.areaName ? `-${category.areaName.toLowerCase()}` : ""
  }`;

  // Format judul breadcrumb
  const breadcrumbTitle = `Sewa ${category.name}${
    category.areaName ? ` ${category.areaName}` : ""
  }`.trim();

  return (
    <>
      <Breadcrumb
        title={breadcrumbTitle}
        subtitle={category.title}
        pages={[
          {
            title: breadcrumbTitle,
            slug: fullSlug,
          },
        ]}
      />

      {/* One Page Navigation */}
      <Navigation
        navMenu={[
          {
            label: "Produk",
            title: `List Produk ${category.name} Sewaan`,
            href: "#produk",
          },
          {
            label: "Cakupan",
            title: `Lokasi Penyewaan ${category.name}`,
            href: "#coverage",
          },
          {
            label: `Sewa ${category.name}`,
            title: `Penyewaan ${category.name}`,
            href: "#content",
          },
          {
            label: "Penawaran",
            title: `Harga Sewa ${category.name}`,
            href: "#cta",
          },
          {
            label: "FAQ",
            title: `Sewa ${category.name} Terdekat`,
            href: "#globalFaq",
          },
        ]}
      />

      <Products category={category} />
      <Categories />
      <Coverage
        categoryName={category.name}
        categorySlug={category.url.replaceAll("/", "")}
      />
      <Content content={category.content} />
      <Newsletter categoryName={category.name} className="py-17.5" />
      <Faq categoryName={category.categoryName} areaName={category.areaName} />
    </>
  );
};

export default Category;
